const pendingAffiliateKey = "pm_pending_affiliate";
const solanaAddressPattern = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

function canUseStorage() {
  return typeof window !== "undefined" && Boolean(window.sessionStorage);
}

export function captureAffiliateFromSearch(search) {
  if (!canUseStorage()) return;
  const params = new URLSearchParams(search || "");
  if (!params.has("aff")) return;
  const aff = String(params.get("aff") || "").trim();
  if (isSolanaAddress(aff)) {
    window.sessionStorage.setItem(pendingAffiliateKey, aff);
    return;
  }
  window.sessionStorage.removeItem(pendingAffiliateKey);
}

export function getPendingAffiliateId() {
  if (!canUseStorage()) return null;
  const value = String(window.sessionStorage.getItem(pendingAffiliateKey) || "").trim();
  return isSolanaAddress(value) ? value : null;
}

function isSolanaAddress(value) {
  return solanaAddressPattern.test(String(value || ""));
}
